<template>
    <transition name="fade">
        <div class="patient-coaching-summary">

            <h4>{{ $i18n.gt('HEADING_MINDSET') }}</h4>
            <patient-coaching-summary-mindset/>

            <hr/>

            <h4>{{ $i18n.gt('HEADING_HABITS') }}</h4>
            <patient-coaching-summary-habits/>

            <hr/>

            <h4 class="mt-3">{{ $i18n.gt('HEADING_LOGS') }}</h4>
            <patient-coaching-summary-logs/>

            <hr/>

            <h4 class="mt-3">{{ $i18n.gt('HEADING_GOALS') }}</h4>
            <patient-coaching-summary-goals/>

            <hr/>

            <h4 class="mt-3">{{ $i18n.gt('HEADING_PATH') }}</h4>
            <patient-coaching-summary-path/>

        </div>
    </transition>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import Vue from 'vue'

export default Vue.extend({
    name: 'PatientCoachingSummary',
    computed: {
        participant() {
            return this.$store.state.patientParticipant
        },
    }
})
</script>
